import React from 'react'
import classnames from 'classnames'

import styles from './styles.css'

const CalendarModal = ({ calendars }) => (
  <div className={classnames(styles.container)}>
    <div className={classnames(styles.title)}>Choose a Calendar</div>
    <div className={classnames(styles.optionContainer)}>
      {calendars.map(ele => (
        <button className={classnames(styles.button)} onClick={ele.function}>
          <i style={{ fontSize: 20, width: 20 }} className={ele.icon} />
          <div className={classnames(styles.name)}>{ele.name}</div>
          <i className="fa fa-chevron-right" style={{ fontSize: 15 }} />
        </button>
      ))}
    </div>
  </div>
)

export default CalendarModal



// WEBPACK FOOTER //
// ./src/views/search/calendar-modal/index.js